import { formatDate } from "@angular/common";

export class DateUtil {

  static getFormatedDate(originalFormat: string, dateToFormat: string): string {
    let formatedDate: string = '';
    let formatVariablesSet: boolean = false;

    let yyyy: string = '';
    let mm: string = '';
    let dd: string = '';
    let hh24: string = '';
    let mi: string = '';
    let ss: string = '';

    switch (originalFormat) {
      case '204':
        if (dateToFormat.length == 14) {
          yyyy = dateToFormat.substring(0, 4);
          mm = dateToFormat.substring(4, 6);
          dd = dateToFormat.substring(6, 8);
          hh24 = dateToFormat.substring(8, 10);
          mi = dateToFormat.substring(10, 12);
          ss = dateToFormat.substring(12, 14);

          formatVariablesSet = true;
        }
        break;
    }

    if (formatVariablesSet) {
      formatedDate = `${dd}/${mm}/${yyyy} ${hh24}:${mi}:${ss}`;
    } else {
      formatedDate = dateToFormat;
    }

    return formatedDate;
  }

  static getDateTimeFormat(value: any): string {
    if (value == null || value == '') {
      return '';
    }
    let date: Date = new Date(value);
    const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with 0
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear(); // Get full year
    const hours = String(date.getHours()).padStart(2, '0');;
    const minutes = String(date.getMinutes()).padStart(2, '0');;
    const seconds = String(date.getSeconds()).padStart(2, '0');;
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  static getDateFormat(value: string): string {  
    if (value == null) {
      return '';
    }

    let date: Date = new Date(value);
    const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with 0
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear(); // Get full year
    return `${day}/${month}/${year}`;
  }

  static getYesNoDateTimeFormat(value: any): string{
    if(value){
      const datetime = this.getDateTimeFormat(value);
      return  'Yes (' + datetime + ')';
    }else{
      return 'No';
    }
  }

  static getNullifiedNoDateTimeFormat(value: any): string{
    if(value){
      const datetime = this.getDateTimeFormat(value);
      return  'Nullified (' + datetime + ')';
    }else{
      return 'No';
    }
  }

  static getDateTime(): string {
    const date = new Date();
  
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hour = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
  
    return `${year}-${month}-${day}+${hour}.${minutes}.${seconds}`;
  }

  static importDate(date: string, format?: number) {

    if (date) {
      let formatedDate: string = '';
      const year = date.substring(0, 4);
      const month = date.substring(4, 6);
      let dateFormat = format
      if (dateFormat == undefined || dateFormat == null){
        dateFormat = this.detectDateFormat(date)
      }
      
      switch (Number(dateFormat).valueOf()){
        case 102:
          const day = date.substring(6, 8);
          formatedDate = `${day}/${month}/${year}`;
          break;
        case 610: 
          formatedDate = `${month}/${year}`;
          break;
      }
      return formatedDate;
    } else {
      return null;
    }

  }

  static getDate(versionDate: number): string {
    let result = "";
    if (versionDate) {
      const strNum = versionDate.toString();
      const year = strNum.slice(0, 4);
      const month = strNum.slice(4, 6);
      const day = strNum.slice(6, 8);
      result = `${day}/${month}/${year}`;
    }
    return result;
  }

  static getParseToNumber(versionDate: String): Number {
    const datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const match = versionDate.match(datePattern);

    if (!match) {
      throw new Error('Error format "dd/mm/yyyy".');
    }

    const day = match[1];
    const month = match[2];
    const year = match[3];

    // Return the date in format 'yyyymmdd'
    return Number(`${year}${month}${day}`);
  }

  static detectDateFormat(date: string): number{
    let formatCode: number = 102; // by default
    if (date) {
      switch(date.length){
        case 6:
          formatCode = 610;
          break;
        case 8: 
          formatCode = 102;
          break;  
      }  
    }

    return formatCode;
    
  }

  static exportDate(date: string, format: number): string {
    let formatedDate: string = '';
    if (date){
      switch(Number(format).valueOf()){
        case 102:
          if (date.length === 10){
            const [dd, mm, yyyy] = date.split('/');        
            formatedDate = `${yyyy}${mm}${dd}`;
          }
          break;
        case 610:
          if (date.length === 7){
            const [mm, yyyy] = date.split('/');        
            formatedDate = `${yyyy}${mm}`;
          }
          break;
      }  
    }

    return formatedDate;

  }

  static getResultDateTime(): string {
    const date = new Date();
  
    const year = date.getFullYear();
    const month = formatDate(date, 'MMMM', 'en');;
    const day = date.getDate().toString().padStart(2, '0');
    const week = formatDate(date, 'EEEE', 'en');
    const hour = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${week}, ${day} ${month} ${year} ${hour}:${minutes}:${seconds}`;

  }

}
